import Common                                         from '../modules/common';
import {apiClientWithUserToken as apiClient, apiList} from '../modules/apiClient';

const DownloadMixin = {
  data   : () => ({
    downloading     : false,
    downloadProgress: null,
    downloadType    : {
      csv  : 'application/csv',
      excel: 'application/octet-stream',
    },
  }),
  methods: {
    downloadFile(path, filename, downloadType = this.downloadType.csv) {
      const self            = this;
      self.downloadProgress = null;
      return new Promise((resolve, reject) => {
        apiClient
          .request({
            url               : apiList.download.file,
            method            : 'post',
            responseType      : 'arraybuffer',
            data              : {
              path: path,
            },
            onDownloadProgress: progressEvent => {
              self.downloadProgress = Math.floor(progressEvent.loaded / progressEvent.total * 100) + '%';
            },
          })
          .then(response => {
            if (response.data) {
              const blob = new Blob([response.data], {type: downloadType})
              saveAs(blob, filename);
              return resolve(true);
            }
            return resolve(false);
          })
          .catch(error => {
            return reject(Common.messages.errorDownload);
          });
      });
    },
  },
};

export default DownloadMixin;
